import { render, staticRenderFns } from "./PanelUser.vue?vue&type=template&id=a2675f42"
import script from "./PanelUser.vue?vue&type=script&lang=js"
export * from "./PanelUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports